// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutModal_container__0gwF8","priceBox":"CheckoutModal_priceBox__2ISVL","heading":"CheckoutModal_heading__xETEv","total":"CheckoutModal_total__sPyJQ"};